import * as React from 'react';
type Props = {
  className?: string;
};
export function Trash({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Trash"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4788 2C14.6581 2 15.7214 2.68995 16.2068 3.75167L16.2823 3.93201L16.689 4.999L18.9231 5H18.923H20V7H18.723L17.7628 16.6026C17.7628 18.4609 16.3066 19.979 14.473 20.0782L14.2821 20.0833H9.64103C7.78273 20.0833 6.26455 18.6271 6.16541 16.7935L6.16026 16.6026L5.2 7H4V5H5L7.309 4.999L7.7177 3.93201C8.13753 2.82997 9.16079 2.08201 10.3258 2.00633L10.5212 2H13.4788ZM17 7H7L8.25 16.7778C8.25 17.4046 8.73255 17.9212 9.35422 17.9918L9.5 18H14.5C15.1904 18 15.75 17.4528 15.75 16.7778L17 7ZM13.4788 4H10.5212C10.1477 4 9.80919 4.20756 9.63753 4.53175L9.58667 4.644L9.451 4.999H14.548L14.4133 4.644C14.2804 4.29502 13.9659 4.05256 13.6018 4.00756L13.4788 4Z"
        fill="currentColor"
      />
    </svg>
  );
}
